import type { KgFlowNode } from "../types";
import {
  parseDataSourceAssetId,
  parseFocusIdFromHref,
  parseMetricAssetId,
  parseOntologyDomainId,
  parseSchemaAssetId,
  toDataSourceCanvasNodeId,
  toMetricCanvasNodeId,
  toOntologyCanvasNodeId,
  toSchemaCanvasNodeId,
  toTableCanvasNodeId,
} from "../../../../services/kg/kgNodeIds";

const findVisibleNodeId = (
  candidateId: string,
  visibleNodes: KgFlowNode[],
): string | null =>
  visibleNodes.some((node) => node.id === candidateId) ? candidateId : null;

/**
 * Resolves an inspector focus id to a node id currently on the canvas.
 * Accepts full canvas ids, raw asset UUIDs, or `/graph?focus=...` hrefs.
 */
export function resolveVisibleCanvasNodeId(
  focusId: string,
  visibleNodes: KgFlowNode[],
): string | null {
  const normalizedFocusId = parseFocusIdFromHref(focusId) ?? focusId;

  const exact = findVisibleNodeId(normalizedFocusId, visibleNodes);
  if (exact) return exact;

  const candidates = [
    toTableCanvasNodeId(parseSchemaAssetId(normalizedFocusId)),
    toSchemaCanvasNodeId(parseSchemaAssetId(normalizedFocusId)),
    toMetricCanvasNodeId(parseMetricAssetId(normalizedFocusId)),
    toOntologyCanvasNodeId(parseOntologyDomainId(normalizedFocusId)),
    toDataSourceCanvasNodeId(parseDataSourceAssetId(normalizedFocusId)),
  ];

  for (const candidateId of candidates) {
    const resolved = findVisibleNodeId(candidateId, visibleNodes);
    if (resolved) return resolved;
  }

  return null;
}
